webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_line_chart_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_line_chart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Chart = __webpack_require__(12);

var tooltipPlugin = {
  beforeRender: function beforeRender(chart) {
    if (chart.config.data.datasets.length > 0) {
      if (chart.config.options.showAllTooltips) {
        chart.pluginTooltips = [];
        chart.config.data.datasets.forEach(function (dataset, i) {
          chart.getDatasetMeta(i).data.forEach(function (sector, j) {
            chart.pluginTooltips.push(new Chart.Tooltip({
              _chart: chart.chart,
              _chartInstance: chart,
              _data: chart.data,
              _options: chart.options.tooltips,
              _active: [sector]
            }, chart));
          });
        });

        chart.options.tooltips.enabled = false;
      }
    }
  },
  afterDraw: function afterDraw(chart, easing) {
    if (chart.config.options.showAllTooltips) {
      if (!chart.allTooltipsOnce) {
        if (easing !== 1) {
          return;
        }
        chart.allTooltipsOnce = true;
      }

      chart.options.tooltips.enabled = true;
      Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
        tooltip.initialize();
        tooltip.update();
        tooltip.pivot();
        tooltip.transition(easing).draw();
      });
      chart.options.tooltips.enabled = false;
    }
  }
};

module.exports = tooltipPlugin;
Chart.pluginService.register(tooltipPlugin);

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  props: ['theme'],
  computed: {
    buildSlides: function buildSlides() {
      return this.$store.state.allSlides;
    },
    currentTheme: function currentTheme() {
      if (this.$route.query.theme === '80s80s' || this.$route.query.theme === '90s90s' || this.$route.query.theme === '1deutsch') {
        return 'theme-' + this.$route.query.theme;
      } else {
        return this.$route.query.theme ? this.$route.query.theme : this.$route.params.display;
      }
    }
  },
  created: function created() {
    var _this = this;

    var self = this;
    self.$store.dispatch('loadConfig', this.$route.params.display).then(function () {
      self.$store.dispatch('showNextSlide');

      // slide interval
      self.slideInt = setInterval(self.intervalMethod, self.$store.state.slideTimeout);

      // stop slides and naviagate via arrow keys
      window.addEventListener('keydown', _this.keyCodes, false);
    });
  },

  methods: {
    intervalMethod: function intervalMethod(event) {
      if (!document.hidden) {
        this.$store.dispatch('showNextSlide');
      }
    },
    keyCodes: function keyCodes(event) {
      /* space = stop / restart slide interval */
      if (event.keyCode === 32) {
        if (this.slideInt) {
          clearInterval(this.slideInt);
          this.slideInt = null;
        } else {
          this.slideInt = setInterval(this.intervalMethod, this.$store.state.slideTimeout);
          this.$store.dispatch('showNextSlide');
        }
      } else if (event.keyCode === 39 && this.slideInt === null) {
        this.$router.forward();
      } else if (event.keyCode === 37 && this.slideInt === null) {
        this.$router.back();
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_daily_active_users_web__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_monthly_active_users_web__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_daily_active_users_app__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_monthly_active_users_app__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sessions_app__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sessions_web__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_engagement__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_fans__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_impressions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_users_reached__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_users_and_fans__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_stream_sessions__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_stream_duration__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_all_simulcasts_all_aggregators__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_all_streams_all_aggregators__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_all_session_starts__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_stream_conversion__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_overview__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_streams_web_only__ = __webpack_require__(484);






















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/:display/streams-web-only',
    name: 'Web only streams',
    component: __WEBPACK_IMPORTED_MODULE_20__components_streams_web_only__["a" /* default */]
  }, {
    path: '/:display/daily-active-users-app',
    name: 'Daily active users app',
    component: __WEBPACK_IMPORTED_MODULE_4__components_daily_active_users_app__["a" /* default */]
  }, {
    path: '/:display/monthly-active-users-app',
    name: 'Monthly active users app',
    component: __WEBPACK_IMPORTED_MODULE_5__components_monthly_active_users_app__["a" /* default */]
  }, {
    path: '/:display/daily-active-users-web',
    name: 'Daily active users web',
    component: __WEBPACK_IMPORTED_MODULE_2__components_daily_active_users_web__["a" /* default */]
  }, {
    path: '/:display/monthly-active-users-web',
    name: 'Monthly active users web',
    component: __WEBPACK_IMPORTED_MODULE_3__components_monthly_active_users_web__["a" /* default */]
  }, {
    path: '/:display/sessions-web',
    name: 'Sessions web',
    component: __WEBPACK_IMPORTED_MODULE_7__components_sessions_web__["a" /* default */]
  }, {
    path: '/:display/sessions-app',
    name: 'Sessions app',
    component: __WEBPACK_IMPORTED_MODULE_6__components_sessions_app__["a" /* default */]
  }, {
    path: '/:display/engagement',
    name: 'Engagement',
    component: __WEBPACK_IMPORTED_MODULE_8__components_engagement__["a" /* default */]
  }, {
    path: '/:display/fans',
    name: 'Fans',
    component: __WEBPACK_IMPORTED_MODULE_9__components_fans__["a" /* default */]
  }, {
    path: '/:display/impressions',
    name: 'Impressions',
    component: __WEBPACK_IMPORTED_MODULE_10__components_impressions__["a" /* default */]
  }, {
    path: '/:display/users-reached',
    name: 'Users reached',
    component: __WEBPACK_IMPORTED_MODULE_11__components_users_reached__["a" /* default */]
  }, {
    path: '/:display/users-and-fans',
    name: 'Users and fans',
    component: __WEBPACK_IMPORTED_MODULE_12__components_users_and_fans__["a" /* default */]
  }, {
    path: '/:display/stream-sessions',
    name: 'Stream sessions',
    component: __WEBPACK_IMPORTED_MODULE_13__components_stream_sessions__["a" /* default */]
  }, {
    path: '/:display/stream-duration',
    name: 'Stream duration',
    component: __WEBPACK_IMPORTED_MODULE_14__components_stream_duration__["a" /* default */]
  }, {
    path: '/:display/all-simulcasts-all-aggregators',
    name: 'All simulcasts, all aggregators',
    component: __WEBPACK_IMPORTED_MODULE_15__components_all_simulcasts_all_aggregators__["a" /* default */]
  }, {
    path: '/:display/all-streams-all-aggregators',
    name: 'All streams, all aggregators',
    component: __WEBPACK_IMPORTED_MODULE_16__components_all_streams_all_aggregators__["a" /* default */]
  }, {
    path: '/:display/all-session-starts',
    name: 'All session starts',
    component: __WEBPACK_IMPORTED_MODULE_17__components_all_session_starts__["a" /* default */]
  }, {
    path: '/:display/stream-conversion',
    name: 'Stream conversion',
    component: __WEBPACK_IMPORTED_MODULE_18__components_stream_conversion__["a" /* default */]
  }, {
    path: '/:display/overview',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_19__components_overview__["a" /* default */]
  }, {
    path: '/:display/',
    name: 'Start without slug'
  }, {
    path: '/:display',
    redirect: '/:display/'
  }, {
    path: '/:display/*',
    name: 'Start with slug'
  }]
});

// get page data before entering route
router.beforeEach(function (to, from, next) {
  if (to.query.source === undefined) {
    to.query.source = 'app';
  }
  if (to.query.theme === undefined) {
    to.query.theme = to.params.display;
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'daily-active-users-web',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_daily_active_users_web-yesterday';

    /* total value */
    var totalValueURL = urlPart;
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).dailyActiveUsers);
    });

    /* 7 days */
    var days7ValueURL = urlPart + '_vs_7_days_ago';
    this.axios.get(days7ValueURL).then(function (response) {
      _this.days7Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 14 days */
    var days14ValueURL = urlPart + '_vs_14_days_ago';
    this.axios.get(days14ValueURL).then(function (response) {
      _this.days14Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 21 days */
    var days21ValueURL = urlPart + '_vs_21_days_ago';
    this.axios.get(days21ValueURL).then(function (response) {
      _this.days21Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monthly-active-users-web',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_monthly_active_users_web';

    /* total value */
    var totalValueURL = urlPart + '-yesterday';
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).monthlyActiveUsers);
    });

    /* 7 days */
    var days7ValueURL = urlPart + '-yesterday_vs_7_days_ago';
    this.axios.get(days7ValueURL).then(function (response) {
      _this.days7Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 14 days */
    var days14ValueURL = urlPart + '-yesterday_vs_14_days_ago';
    this.axios.get(days14ValueURL).then(function (response) {
      _this.days14Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 21 days */
    var days21ValueURL = urlPart + '-yesterday_vs_21_days_ago';
    this.axios.get(days21ValueURL).then(function (response) {
      _this.days21Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'daily-active-users-app',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_daily_active_users_app-yesterday';

    /* total value */
    var totalValueURL = urlPart;
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).dailyActiveUsers);
    });

    /* 7 days */
    var days7ValueURL = urlPart + '_vs_7_days_ago';
    this.axios.get(days7ValueURL).then(function (response) {
      _this.days7Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 14 days */
    var days14ValueURL = urlPart + '_vs_14_days_ago';
    this.axios.get(days14ValueURL).then(function (response) {
      _this.days14Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 21 days */
    var days21ValueURL = urlPart + '_vs_21_days_ago';
    this.axios.get(days21ValueURL).then(function (response) {
      _this.days21Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monthly-active-users-app',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_monthly_active_users_app';

    /* total value */
    var totalValueURL = urlPart + '-yesterday';
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).monthlyActiveUsers);
    });

    /* 7 days */
    var days7ValueURL = urlPart + '-yesterday_vs_7_days_ago';
    this.axios.get(days7ValueURL).then(function (response) {
      _this.days7Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 14 days */
    var days14ValueURL = urlPart + '-yesterday_vs_14_days_ago';
    this.axios.get(days14ValueURL).then(function (response) {
      _this.days14Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* 21 days */
    var days21ValueURL = urlPart + '-yesterday_vs_21_days_ago';
    this.axios.get(days21ValueURL).then(function (response) {
      _this.days21Value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_line_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sessions-app',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_line_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      sessionWebTotalValue: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      chartdata: null,
      chartColor: '#2d76bf',
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_sessions_app';
    var currentSlide = this.$store.state.allSlides[this.$route.query.id];

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor;
    }

    /* total value */
    var totalValueURL = urlPart + '-yesterday';
    self.axios.get(totalValueURL).then(function (response) {
      self.sessionWebTotalValue = parseInt(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results)['App Sitzungen']);
    });

    /* chart data */
    var chartDataURL = urlPart + '-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });

    /* 7 days */
    var days7ValueURL = urlPart + '-yesterday_vs_7_days_ago';
    this.axios.get(days7ValueURL).then(function (response) {
      _this.days7Value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results).perc;
    });

    /* 14 days */
    var days14ValueURL = urlPart + '-yesterday_vs_14_days_ago';
    this.axios.get(days14ValueURL).then(function (response) {
      _this.days14Value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results).perc;
    });

    /* 21 days */
    var days21ValueURL = urlPart + '-yesterday_vs_21_days_ago';
    this.axios.get(days21ValueURL).then(function (response) {
      _this.days21Value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results).perc;
    });
  },

  methods: {
    fillData: function fillData(data) {
      var sessions = [];
      var days = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(data, function (entry) {
        sessions.push(parseInt(entry['App Sitzungen']));
        days.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(entry._time).locale('de').format('dd D'));
      });

      this.chartdata = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Sitzungen',
          backgroundColor: this.chartColor,
          data: sessions
        }]
      };
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  props: ['data'],
  mounted: function mounted() {
    var fontColor = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#app').css('color');
    var fontSize = parseInt(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#app').css('font-size')) * 0.6;
    var unit = this.$el.dataset.unit ? this.$el.dataset.unit : '';

    this.addPlugin(__WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin___default.a);

    this.options = {
      showAllTooltips: true,
      layout: {
        padding: {
          left: 40,
          right: 40,
          top: 40,
          bottom: 0
        }
      },
      tooltips: {
        backgroundColor: 'rgba(255,255,255,0.75)',
        titleFontColor: '#333',
        titleFontStyle: 'normal',
        titleFontSize: fontSize,
        yAlign: 'bottom',
        xAlign: 'center',
        xPadding: 6,
        yPadding: 3,
        cornerRadius: 2,
        callbacks: {
          title: function title(tooltipItem, chart) {
            return tooltipItem[0].yLabel.toLocaleString() + unit;
          },
          label: function label() {}
        }
      },
      legend: {
        position: 'bottom',
        labels: {
          fontColor: fontColor,
          fontSize: fontSize * 1.1,
          usePointStyle: true,
          fontStyle: 'bold',
          position: 'bottom'
        }
      },
      scales: {
        yAxes: [{
          display: false
        }],
        xAxes: [{
          ticks: {
            fontColor: fontColor,
            fontSize: fontSize - 2
          }
        }]
      },
      animation: {
        easing: this.$store.state.chartAnimationEasing,
        duration: this.$store.state.chartAnimationTime
      }
    };

    this.renderChart(this.data, this.options);
  }
}));

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_charts_line_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sessions-web',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_1__components_charts_line_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      sessionWebTotalValue: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      chartdata: null,
      chartColor: '#2d76bf',
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_sessions_web';
    var currentSlide = this.$store.state.allSlides[this.$route.query.id];

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor;
    }

    /* total value */
    var totalValueURL = urlPart + '-yesterday';
    self.axios.get(totalValueURL).then(function (response) {
      self.sessionWebTotalValue = parseInt(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results)['Website Sitzungen']);
    });

    /* chart data */
    var chartDataURL = urlPart + '-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });

    /* 7 days */
    var days7ValueURL = urlPart + '-yesterday_vs_7_days_ago';
    this.axios.get(days7ValueURL).then(function (response) {
      _this.days7Value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results).perc;
    });

    /* 14 days */
    var days14ValueURL = urlPart + '-yesterday_vs_14_days_ago';
    this.axios.get(days14ValueURL).then(function (response) {
      _this.days14Value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results).perc;
    });

    /* 21 days */
    var days21ValueURL = urlPart + '-yesterday_vs_21_days_ago';
    this.axios.get(days21ValueURL).then(function (response) {
      _this.days21Value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(response.data.results).perc;
    });
  },

  methods: {
    fillData: function fillData(data) {
      var sessions = [];
      var days = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(data, function (entry) {
        sessions.push(parseInt(entry['Website Sitzungen']));
        days.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(entry._time).locale('de').format('dd D'));
      });

      this.chartdata = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Sitzungen',
          backgroundColor: this.chartColor,
          data: sessions
        }]
      };
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'engagement',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      dataReactions: null,
      dataComments: null,
      dataShares: null,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ',',
        suffix: '%'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_engagement';

    /* total value */
    var totalValueURL = urlPart + '-last_7_days_vs_7_days_ago';
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).percent.replace(',', '.'));
    });

    /* chart data */
    var chartDataURL = urlPart + '-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });
  },

  methods: {
    fillData: function fillData(data) {
      var reactions = [];
      var comments = [];
      var shares = [];
      var days = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        reactions.push(parseInt(entry.reactions));
        comments.push(parseInt(entry.comments));
        shares.push(parseInt(entry.shares));
        days.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(entry._time).locale('de').format('dd D'));
      });

      /* paid likes */
      this.dataReactions = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Reaktionen',
          backgroundColor: '#345996',
          data: reactions
        }]

        /* organic likes */
      };this.dataComments = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Kommentare',
          backgroundColor: '#3cab3f',
          data: comments
        }]

        /* unlikes */
      };this.dataShares = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Shares',
          backgroundColor: '#b21089',
          data: shares
        }]
      };
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fans',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      dataPaid: null,
      dataOrganic: null,
      dataUnlikes: null,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ',',
        suffix: '%'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_fans';

    /* total value */
    var totalValueURL = urlPart + '-last_7_days_vs_7_days_ago';
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).percent.replace(',', '.'));
    });

    /* chart data */
    var chartDataURL = urlPart + '_page_likes-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });
  },

  methods: {
    fillData: function fillData(data) {
      var unlikes = [];
      var paid = [];
      var organic = [];
      var days = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        unlikes.push(parseInt(entry.unlike));
        paid.push(parseInt(entry.paid));
        organic.push(parseInt(entry.organic));
        days.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(entry._time).locale('de').format('dd D'));
      });

      /* paid likes */
      this.dataPaid = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Bezahlt',
          backgroundColor: '#345895',
          data: paid
        }]

        /* organic likes */
      };this.dataOrganic = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Organisch',
          backgroundColor: '#3cab3f',
          data: organic
        }]

        /* unlikes */
      };this.dataUnlikes = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Unlikes',
          backgroundColor: '#ea0617',
          data: unlikes
        }]
      };
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'impressions',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      dataPaid: null,
      dataOrganic: null,
      dataViral: null,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ',',
        suffix: '%'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_impressions';

    /* total value */
    var totalValueURL = urlPart + '-last_7_days_vs_7_days_ago';
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).percent.replace(',', '.'));
    });

    /* chart data */
    var chartDataURL = urlPart + '_a_day-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });
  },

  methods: {
    fillData: function fillData(data) {
      var viral = [];
      var paid = [];
      var organic = [];
      var days = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        viral.push(parseInt(entry.viral));
        paid.push(parseInt(entry.paid));
        organic.push(parseInt(entry.organic));
        days.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(entry._time).locale('de').format('dd D'));
      });

      /* paid likes */
      this.dataPaid = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Bezahlt',
          backgroundColor: '#345996',
          data: paid
        }]

        /* organic likes */
      };this.dataOrganic = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Organisch',
          backgroundColor: '#3cab3f',
          data: organic
        }]

        /* unlikes */
      };this.dataViral = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Viral',
          backgroundColor: '#b21089',
          data: viral
        }]
      };
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_bar_chart__ = __webpack_require__(309);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users-reached',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_bar_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      chartColor: '#2d76bf',
      dataUserAge: null,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_users_reached';
    var currentSlide = this.$store.state.allSlides[this.$route.query.id];

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor;
    }

    /* total value */
    var totalValueURL = urlPart + '-last_7_days';
    self.axios.get(totalValueURL).then(function (response) {
      self.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).UsersReached);
    });

    /* chart data */
    var chartDataURL = urlPart + '_user_age-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });
  },

  methods: {
    fillData: function fillData(data) {
      var groups = [];
      var percents = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        groups.push(entry.group);
        percents.push(parseFloat(entry.percent));
      });

      /* paid likes */
      this.dataUserAge = {
        labels: groups,
        datasets: [{
          label: 'Altersstruktur',
          backgroundColor: this.chartColor,
          data: percents
        }]
      };
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bar_chart_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bar_chart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  props: ['data'],
  mounted: function mounted() {
    var fontColor = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#app').css('color');
    var fontSize = parseInt(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#app').css('font-size')) * 0.66;
    var unit = this.$el.dataset.unit ? this.$el.dataset.unit : '';

    this.addPlugin(__WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin___default.a);

    this.options = {
      showAllTooltips: true,
      layout: {
        padding: {
          top: 40
        }
      },
      tooltips: {
        backgroundColor: 'rgba(255,255,255,0.75)',
        titleFontColor: '#333',
        titleFontStyle: 'normal',
        titleFontSize: fontSize,
        yAlign: 'bottom',
        xAlign: 'center',
        xPadding: 6,
        yPadding: 3,
        cornerRadius: 2,
        callbacks: {
          title: function title(tooltipItem, chart) {
            return tooltipItem[0].yLabel.toLocaleString() + unit;
          },
          label: function label() {}
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          display: false
        }],
        xAxes: [{
          barPercentage: 0.95,
          ticks: {
            fontColor: fontColor,
            fontSize: fontSize * 1.1
          }
        }]
      },
      animation: {
        easing: this.$store.state.chartAnimationEasing,
        duration: this.$store.state.chartAnimationTime
      }
    };

    this.renderChart(this.data, this.options);
  }
}));

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_pie_chart__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_charts_bar_chart__ = __webpack_require__(309);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users-and-fans',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_pie_chart__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_3__components_charts_bar_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      dataGender: null,
      dataUserAge: null,
      chartColor: '#2d76bf',
      pieChartColors: ['#c21192', '#266797', '#ccc'],
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_users_and_fans';
    var urlPart2 = theme + '-' + source + '_users_reached';
    var currentSlide = this.$store.state.allSlides[this.$route.query.id];

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor;
    }
    if (currentSlide.pieChartColors) {
      this.pieChartColors = currentSlide.pieChartColors;
    }

    /* total value */
    var totalValueURL = urlPart;
    self.axios.get(totalValueURL).then(function (response) {
      self.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).Totals);
    });

    /* pie chart data */
    var pieChartDataURL = urlPart + '_by_age';
    self.axios.get(pieChartDataURL).then(function (response) {
      self.fillDataPie(response.data.results);
    });

    /* bar chart data */
    var barChartDataURL = urlPart2 + '_user_age-last_7_days';
    self.axios.get(barChartDataURL).then(function (response) {
      self.fillDataBar(response.data.results);
    });
  },

  methods: {
    fillDataPie: function fillDataPie(data) {
      var groups = [];
      var percents = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        groups.push(entry.gender);
        percents.push(parseFloat(entry.percent));
      });

      /* paid likes */
      this.dataGender = {
        labels: groups,
        datasets: [{
          backgroundColor: this.pieChartColors,
          borderWidth: 0,
          data: percents
        }]
      };
    },
    fillDataBar: function fillDataBar(data) {
      var groups = [];
      var percents = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        groups.push(entry.group);
        percents.push(parseFloat(entry.percent));
      });

      /* paid likes */
      this.dataUserAge = {
        labels: groups,
        datasets: [{
          label: 'Altersstruktur',
          backgroundColor: this.chartColor,
          data: percents
        }]
      };
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pie_chart_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pie_chart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  props: ['data'],
  mounted: function mounted() {
    var fontColor = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#app').css('color');
    var fontSize = parseInt(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#app').css('font-size')) * 0.66;
    var unit = this.$el.dataset.unit ? this.$el.dataset.unit : '';

    this.addPlugin(__WEBPACK_IMPORTED_MODULE_2__components_charts_chartjs_tooltip_plugin___default.a);

    this.options = {
      showAllTooltips: true,
      tooltips: {
        backgroundColor: 'rgba(255,255,255,0.75)',
        titleFontColor: '#333',
        titleFontStyle: 'normal',
        titleFontSize: fontSize,
        yAlign: 'bottom',
        xAlign: 'center',
        xPadding: 5,
        yPadding: 2,
        cornerRadius: 2,
        callbacks: {
          title: function title(tooltipItem, chart) {
            return chart.datasets[0].data[tooltipItem[0].index].toLocaleString() + unit;
          },
          label: function label() {}
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: fontColor,
          fontSize: fontSize * 1.1,
          usePointStyle: true,
          fontStyle: 'bold'
        }
      },
      animation: {
        easing: this.$store.state.chartAnimationEasing,
        duration: this.$store.state.chartAnimationTime
      }
    };

    this.renderChart(this.data, this.options);
  }
}));

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stream-sessions',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueHomepageEnd: 0,
      totalValueAppEnd: 0,
      totalValueRadiodeEnd: 0,
      totalValueTuneinEnd: 0,
      totalValueVtunerEnd: 0,
      differenceHomepage: 0,
      differenceApp: 0,
      differenceRadiode: 0,
      differenceTunein: 0,
      differenceVtuner: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_stream_sessions';

    /* total value homepage */
    var totalValueHomepageURL = urlPart + '_homepage-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueHomepageURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueHomepageEnd = parseInt(results.total_value);
      _this.differenceHomepage = parseInt(results.difference);
    });

    /* total value app */
    var totalValueAppURL = urlPart + '_app-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueAppURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueAppEnd = parseInt(results.total_value);
      _this.differenceApp = parseInt(results.difference);
    });

    /* total value radio.de */
    var totalValueRadiodeURL = urlPart + '_radiode-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueRadiodeURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueRadiodeEnd = parseInt(results.total_value);
      _this.differenceRadiode = parseInt(results.difference);
    });

    /* total value vTuner */
    var totalValueVtunerURL = urlPart + '_vtuner-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueVtunerURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueVtunerEnd = parseInt(results.total_value);
      _this.differenceVtuner = parseInt(results.difference);
    });

    /* total value TuneIn */
    var totalValueTuneinURL = urlPart + '_tunein-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueTuneinURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueTuneinEnd = parseInt(results.total_value);
      _this.differenceTunein = parseInt(results.difference);
    });
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stream-duration',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueHomepageEnd: 0,
      totalValueAppEnd: 0,
      totalValueRadiodeEnd: 0,
      totalValueTuneinEnd: 0,
      totalValueVtunerEnd: 0,
      differenceHomepage: 0,
      differenceApp: 0,
      differenceRadiode: 0,
      differenceTunein: 0,
      differenceVtuner: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        decimal: ','
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_stream_duration';

    /* total value homepage */
    var totalValueHomepageURL = urlPart + '_homepage-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueHomepageURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueHomepageEnd = parseFloat(results.total_value);
      _this.differenceHomepage = parseFloat(results.difference);
    });

    /* total value app */
    var totalValueAppURL = urlPart + '_app-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueAppURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueAppEnd = parseFloat(results.total_value);
      _this.differenceApp = parseFloat(results.difference);
    });

    /* total value radio.de */
    var totalValueRadiodeURL = urlPart + '_radiode-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueRadiodeURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueRadiodeEnd = parseFloat(results.total_value).toFixed(1);
      _this.differenceRadiode = parseFloat(results.difference).toFixed(1);
    });

    /* total value vTuner */
    var totalValueVtunerURL = urlPart + '_vtuner-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueVtunerURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueVtunerEnd = parseFloat(results.total_value).toFixed(1);
      _this.differenceVtuner = parseFloat(results.difference).toFixed(1);
    });

    /* total value TuneIn */
    var totalValueTuneinURL = urlPart + '_tunein-last_7_days_vs_prev_7_days';
    this.axios.get(totalValueTuneinURL).then(function (response) {
      var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results);
      _this.totalValueTuneinEnd = parseFloat(results.total_value).toFixed(1);
      _this.differenceTunein = parseFloat(results.difference).toFixed(1);
    });
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all-simulcasts-all-aggregators',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueSessionStartsYesterday: 0,
      totalValueSessionStartsLast7Days: 0,
      sessionStarts28daysValue: 0,
      sessionStarts14daysValue: 0,
      totalValueSessionDurationYesterday: 0,
      totalValueSessionDurationLast7Days: 0,
      sessionDuration28daysValue: 0,
      sessionDuration14daysValue: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ','
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_all_simulcasts_all_aggregators';
    var urlPart2 = theme + '-stream_duration_all_simulcasts_all_aggregators';

    /* total value session starts: yesterday */
    var sessionStartsTotalValueYesterdayURL = urlPart + '-yesterday';
    this.axios.get(sessionStartsTotalValueYesterdayURL).then(function (response) {
      _this.totalValueSessionStartsYesterday = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).Anzahl);
    });

    /* total value session starts: last 7 days */
    var totalValueLast7DaysURL = urlPart + '-last_7_days';
    this.axios.get(totalValueLast7DaysURL).then(function (response) {
      _this.totalValueSessionStartsLast7Days = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).Anzahl);
    });

    /* total value session starts: yesterday vs last 28 days */
    var sessionStarts28daysURL = urlPart + '-yesterday_vs_28_days_ago';
    this.axios.get(sessionStarts28daysURL).then(function (response) {
      _this.sessionStarts28daysValue = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc);
    });

    /* total value session starts: last 7 days vs last 14 days */
    var sessionStarts14daysURL = urlPart + '-last_7_days_vs_14_days_ago';
    this.axios.get(sessionStarts14daysURL).then(function (response) {
      _this.sessionStarts14daysValue = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* total value session duration: yesterday */
    var durationTotalValueYesterdayURL = urlPart2 + '-yesterday';
    this.axios.get(durationTotalValueYesterdayURL).then(function (response) {
      _this.totalValueSessionDurationYesterday = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).avgDuration);
    });

    /* total value session duration: last 7 days */
    var durationTotalValueLast7DaysURL = urlPart2 + '-last_7_days';
    this.axios.get(durationTotalValueLast7DaysURL).then(function (response) {
      _this.totalValueSessionDurationLast7Days = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).avgDuration);
    });

    /* total value session duration: yesterday vs last 28 days */
    var sessionDuration28daysURL = urlPart2 + '-yesterday_vs_28_days_ago';
    this.axios.get(sessionDuration28daysURL).then(function (response) {
      _this.sessionDuration28daysValue = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc);
    });

    /* total value session duration: last 7 days vs last 14 days */
    var sessionDuration14daysURL = urlPart2 + '-last_7_days_vs_14_days_ago';
    this.axios.get(sessionDuration14daysURL).then(function (response) {
      _this.sessionDuration14daysValue = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc);
    });
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all-streams-all-aggregators',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_line_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      chartColor: '#28727e',
      dataChart: null,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_all_streams_all_aggregators';
    var currentSlide = this.$store.state.allSlides[this.$route.query.id];

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor;
    }

    /* total value */
    var totalValueURL = urlPart + '-last_7_days';
    self.axios.get(totalValueURL).then(function (response) {
      self.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).Anzahl);
    });

    /* total value */
    var chartDataURL = theme + '-stream_session_starts_all_streams_all_aggregators-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });
  },

  methods: {
    fillData: function fillData(data) {
      var sessions = [];
      var days = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        sessions.push(parseInt(entry.start));
        days.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(entry._time).locale('de').format('dd D'));
      });

      /* paid likes */
      this.dataChart = {
        labels: days,
        datasets: [{
          pointBackgroundColor: '#fff',
          label: 'Session Starts',
          backgroundColor: this.chartColor,
          data: sessions
        }]
      };
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_pie_chart__ = __webpack_require__(312);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all-session-starts',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_pie_chart__["a" /* default */]
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      totalValueQualEnd: 0,
      dataSessionLength: null,
      pieChartColors: ['#9f6427', '#4b9f2a', '#3aa18a', '#969120', '#982126'],
      options1: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ','
      },
      options2: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
        suffix: '%'
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_all_session_starts';
    var urlPart2 = theme + '-stream_qual_bouncerate_all_session_starts';
    var urlPart3 = theme + '-stream_duration_cluster_all_session_starts';
    var currentSlide = this.$store.state.allSlides[this.$route.query.id];

    /* chart colors */
    if (currentSlide.pieChartColors) {
      this.pieChartColors = currentSlide.pieChartColors;
    }

    /* average duration */
    var totalValueURL = urlPart + '-last_7_days';
    this.axios.get(totalValueURL).then(function (response) {
      self.totalValueEnd = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).avgDuration);
    });

    /* qual. bouncerate */
    var totalValueQualURL = urlPart2 + '-last_7_days';
    self.axios.get(totalValueQualURL).then(function (response) {
      self.totalValueQualEnd = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).percent);
    });

    /* chart data */
    var chartDataURL = urlPart3 + '-last_7_days';
    self.axios.get(chartDataURL).then(function (response) {
      self.fillData(response.data.results);
    });
  },

  methods: {
    fillData: function fillData(data) {
      var groups = [];
      var percents = [];

      /* fill arrays */
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data, function (entry) {
        groups.push(entry['ICECAST.listenerTimeSegment']);
        percents.push(parseFloat(entry['sum(count)']));
      });

      /* paid likes */
      this.dataSessionLength = {
        labels: groups,
        datasets: [{
          segmentStrokeWidth: 20,
          segmentStrokeColor: 'rgba(255, 255, 255, 0.4)',
          backgroundColor: this.pieChartColors,
          borderWidth: 0,
          data: percents
        }]
      };
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stream-conversion',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
        suffix: '%'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_stream_conversion';

    /* total value */
    var totalValueURL = urlPart + '-last_7_days';
    this.axios.get(totalValueURL).then(function (response) {
      _this.totalValueEnd = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).percent);
    });
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'overview',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      engagementValue: 0,
      engagementDiff: 0,
      impressionsValue: 0,
      impressionsDiff: 0,
      usersReachedValue: 0,
      usersReachedDiff: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var source = this.$route.query.source;
    var urlPart = theme + '-' + source + '_overview';

    /* engagement value */
    var engagementURL = urlPart + '_engagement-last_7_days_vs_7_days_ago';
    this.axios.get(engagementURL).then(function (response) {
      _this.engagementValue = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).total_value);
      _this.engagementDiff = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).difference);
    });

    /* impressions value */
    var impressionsURL = urlPart + '_impressions-last_7_days_vs_7_days_ago';
    this.axios.get(impressionsURL).then(function (response) {
      _this.impressionsValue = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).total_value);
      _this.impressionsDiff = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).difference);
    });

    /* users reached value */
    var usersReachedURL = urlPart + '_user_reached-last_7_days_vs_7_days_ago';
    this.axios.get(usersReachedURL).then(function (response) {
      _this.usersReachedValue = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).total_value);
      _this.usersReachedDiff = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).difference);
    });
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'streams-web-only',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  data: function data() {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueSessionStartsYesterday: 0,
      totalValueSessionStartsLast7Days: 0,
      sessionStarts28daysValue: 0,
      sessionStarts14daysValue: 0,
      totalValueSessionDurationYesterday: 0,
      totalValueSessionDurationLast7Days: 0,
      sessionDuration28daysValue: 0,
      sessionDuration14daysValue: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ','
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var theme = this.$route.query.theme;
    var urlPart = theme + '-' + 'stream_sessions_all_webonlys_all_aggregators';
    var urlPart2 = theme + '-stream_duration_all_webonlys_all_aggregators';

    /* total value session starts: yesterday */
    var sessionStartsTotalValueYesterdayURL = urlPart + '-yesterday';
    this.axios.get(sessionStartsTotalValueYesterdayURL).then(function (response) {
      _this.totalValueSessionStartsYesterday = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).Anzahl);
    });

    /* total value session starts: last 7 days */
    var totalValueLast7DaysURL = urlPart + '-last_7_days';
    this.axios.get(totalValueLast7DaysURL).then(function (response) {
      _this.totalValueSessionStartsLast7Days = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).Anzahl);
    });

    /* total value session starts: yesterday vs last 28 days */
    var sessionStarts28daysURL = urlPart + '-yesterday_vs_28_days_ago';
    this.axios.get(sessionStarts28daysURL).then(function (response) {
      _this.sessionStarts28daysValue = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc);
    });

    /* total value session starts: last 7 days vs last 14 days */
    var sessionStarts14daysURL = urlPart + '-last_7_days_vs_14_days_ago';
    this.axios.get(sessionStarts14daysURL).then(function (response) {
      _this.sessionStarts14daysValue = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc;
    });

    /* total value session duration: yesterday */
    var durationTotalValueYesterdayURL = urlPart2 + '-yesterday';
    this.axios.get(durationTotalValueYesterdayURL).then(function (response) {
      _this.totalValueSessionDurationYesterday = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).avgDuration);
    });

    /* total value session duration: last 7 days */
    var durationTotalValueLast7DaysURL = urlPart2 + '-last_7_days';
    this.axios.get(durationTotalValueLast7DaysURL).then(function (response) {
      _this.totalValueSessionDurationLast7Days = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).avgDuration);
    });

    /* total value session duration: yesterday vs last 28 days */
    var sessionDuration28daysURL = urlPart2 + '-yesterday_vs_28_days_ago';
    this.axios.get(sessionDuration28daysURL).then(function (response) {
      _this.sessionDuration28daysValue = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc);
    });

    /* total value session duration: last 7 days vs last 14 days */
    var sessionDuration14daysURL = urlPart2 + '-last_7_days_vs_14_days_ago';
    this.axios.get(sessionDuration14daysURL).then(function (response) {
      _this.sessionDuration14daysValue = parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(response.data.results).perc);
    });
  }
});

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(487);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = 'https://splunk-connector.loverad.io/api/v1/saved_search_result/';
// axios.defaults.baseURL = 'https://splunk-connector-new.loverad.io/api/v1/saved_search_result/'

/* use plugins */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_996d52e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(356);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_996d52e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */,
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.currentTheme,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */,
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_active_users_web_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba77344_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_active_users_web_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_active_users_web_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba77344_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_active_users_web_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox daily-active-users-web",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Nutzer\n    ")])]),_vm._v(" "),_c('div',{staticClass:"total-value daily-active-users-web-total"},[_c('h2',[_vm._v("Daily active users")]),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle daily-active-users-web-7days",class:[_vm.days7Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days7Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle daily-active-users-web-14days",class:[_vm.days14Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days14Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle daily-active-users-web-21days",class:[_vm.days21Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days21Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("21 Tage zuvor")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monthly_active_users_web_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44615e9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_monthly_active_users_web_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monthly_active_users_web_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44615e9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_monthly_active_users_web_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox monthly-active-users-web",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Nutzer\n    ")])]),_vm._v(" "),_c('div',{staticClass:"total-value monthly-active-users-web-total"},[_c('h2',[_vm._v("Monthly active users")]),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle monthly-active-users-web-7days",class:[_vm.days7Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days7Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle monthly-active-users-web-14days",class:[_vm.days14Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days14Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle monthly-active-users-web-21days",class:[_vm.days21Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days21Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("21 Tage zuvor")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_active_users_app_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74623718_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_active_users_app_vue__ = __webpack_require__(366);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_active_users_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74623718_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_active_users_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox daily-active-users-app",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Nutzer\n    ")])]),_vm._v(" "),_c('div',{staticClass:"total-value daily-active-users-app-total"},[_c('h2',[_vm._v("Daily active users")]),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle daily-active-users-app-7days",class:[_vm.days7Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days7Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle daily-active-users-app-14days",class:[_vm.days14Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days14Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle daily-active-users-app-21days",class:[_vm.days21Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days21Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("21 Tage zuvor")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monthly_active_users_app_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1e05f40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_monthly_active_users_app_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_monthly_active_users_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1e05f40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_monthly_active_users_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox monthly-active-users-app",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Nutzer\n    ")])]),_vm._v(" "),_c('div',{staticClass:"total-value monthly-active-users-app-total"},[_c('h2',[_vm._v("Monthly active users")]),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle monthly-active-users-app-7days",class:[_vm.days7Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days7Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle monthly-active-users-app-14days",class:[_vm.days14Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days14Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle monthly-active-users-app-21days",class:[_vm.days21Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days21Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("21 Tage zuvor")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sessions_app_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389b027b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sessions_app_vue__ = __webpack_require__(444);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sessions_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389b027b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sessions_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 61,
	"./af.js": 61,
	"./ar": 62,
	"./ar-dz": 63,
	"./ar-dz.js": 63,
	"./ar-kw": 64,
	"./ar-kw.js": 64,
	"./ar-ly": 65,
	"./ar-ly.js": 65,
	"./ar-ma": 66,
	"./ar-ma.js": 66,
	"./ar-sa": 67,
	"./ar-sa.js": 67,
	"./ar-tn": 68,
	"./ar-tn.js": 68,
	"./ar.js": 62,
	"./az": 69,
	"./az.js": 69,
	"./be": 70,
	"./be.js": 70,
	"./bg": 71,
	"./bg.js": 71,
	"./bn": 72,
	"./bn.js": 72,
	"./bo": 73,
	"./bo.js": 73,
	"./br": 74,
	"./br.js": 74,
	"./bs": 75,
	"./bs.js": 75,
	"./ca": 76,
	"./ca.js": 76,
	"./cs": 77,
	"./cs.js": 77,
	"./cv": 78,
	"./cv.js": 78,
	"./cy": 79,
	"./cy.js": 79,
	"./da": 80,
	"./da.js": 80,
	"./de": 81,
	"./de-at": 82,
	"./de-at.js": 82,
	"./de-ch": 83,
	"./de-ch.js": 83,
	"./de.js": 81,
	"./dv": 84,
	"./dv.js": 84,
	"./el": 85,
	"./el.js": 85,
	"./en-au": 86,
	"./en-au.js": 86,
	"./en-ca": 87,
	"./en-ca.js": 87,
	"./en-gb": 88,
	"./en-gb.js": 88,
	"./en-ie": 89,
	"./en-ie.js": 89,
	"./en-nz": 90,
	"./en-nz.js": 90,
	"./eo": 91,
	"./eo.js": 91,
	"./es": 92,
	"./es-do": 93,
	"./es-do.js": 93,
	"./es.js": 92,
	"./et": 94,
	"./et.js": 94,
	"./eu": 95,
	"./eu.js": 95,
	"./fa": 96,
	"./fa.js": 96,
	"./fi": 97,
	"./fi.js": 97,
	"./fo": 98,
	"./fo.js": 98,
	"./fr": 99,
	"./fr-ca": 100,
	"./fr-ca.js": 100,
	"./fr-ch": 101,
	"./fr-ch.js": 101,
	"./fr.js": 99,
	"./fy": 102,
	"./fy.js": 102,
	"./gd": 103,
	"./gd.js": 103,
	"./gl": 104,
	"./gl.js": 104,
	"./gom-latn": 105,
	"./gom-latn.js": 105,
	"./he": 106,
	"./he.js": 106,
	"./hi": 107,
	"./hi.js": 107,
	"./hr": 108,
	"./hr.js": 108,
	"./hu": 109,
	"./hu.js": 109,
	"./hy-am": 110,
	"./hy-am.js": 110,
	"./id": 111,
	"./id.js": 111,
	"./is": 112,
	"./is.js": 112,
	"./it": 113,
	"./it.js": 113,
	"./ja": 114,
	"./ja.js": 114,
	"./jv": 115,
	"./jv.js": 115,
	"./ka": 116,
	"./ka.js": 116,
	"./kk": 117,
	"./kk.js": 117,
	"./km": 118,
	"./km.js": 118,
	"./kn": 119,
	"./kn.js": 119,
	"./ko": 120,
	"./ko.js": 120,
	"./ky": 121,
	"./ky.js": 121,
	"./lb": 122,
	"./lb.js": 122,
	"./lo": 123,
	"./lo.js": 123,
	"./lt": 124,
	"./lt.js": 124,
	"./lv": 125,
	"./lv.js": 125,
	"./me": 126,
	"./me.js": 126,
	"./mi": 127,
	"./mi.js": 127,
	"./mk": 128,
	"./mk.js": 128,
	"./ml": 129,
	"./ml.js": 129,
	"./mr": 130,
	"./mr.js": 130,
	"./ms": 131,
	"./ms-my": 132,
	"./ms-my.js": 132,
	"./ms.js": 131,
	"./my": 133,
	"./my.js": 133,
	"./nb": 134,
	"./nb.js": 134,
	"./ne": 135,
	"./ne.js": 135,
	"./nl": 136,
	"./nl-be": 137,
	"./nl-be.js": 137,
	"./nl.js": 136,
	"./nn": 138,
	"./nn.js": 138,
	"./pa-in": 139,
	"./pa-in.js": 139,
	"./pl": 140,
	"./pl.js": 140,
	"./pt": 141,
	"./pt-br": 142,
	"./pt-br.js": 142,
	"./pt.js": 141,
	"./ro": 143,
	"./ro.js": 143,
	"./ru": 144,
	"./ru.js": 144,
	"./sd": 145,
	"./sd.js": 145,
	"./se": 146,
	"./se.js": 146,
	"./si": 147,
	"./si.js": 147,
	"./sk": 148,
	"./sk.js": 148,
	"./sl": 149,
	"./sl.js": 149,
	"./sq": 150,
	"./sq.js": 150,
	"./sr": 151,
	"./sr-cyrl": 152,
	"./sr-cyrl.js": 152,
	"./sr.js": 151,
	"./ss": 153,
	"./ss.js": 153,
	"./sv": 154,
	"./sv.js": 154,
	"./sw": 155,
	"./sw.js": 155,
	"./ta": 156,
	"./ta.js": 156,
	"./te": 157,
	"./te.js": 157,
	"./tet": 158,
	"./tet.js": 158,
	"./th": 159,
	"./th.js": 159,
	"./tl-ph": 160,
	"./tl-ph.js": 160,
	"./tlh": 161,
	"./tlh.js": 161,
	"./tr": 162,
	"./tr.js": 162,
	"./tzl": 163,
	"./tzl.js": 163,
	"./tzm": 164,
	"./tzm-latn": 165,
	"./tzm-latn.js": 165,
	"./tzm.js": 164,
	"./uk": 166,
	"./uk.js": 166,
	"./ur": 167,
	"./ur.js": 167,
	"./uz": 168,
	"./uz-latn": 169,
	"./uz-latn.js": 169,
	"./uz.js": 168,
	"./vi": 170,
	"./vi.js": 170,
	"./x-pseudo": 171,
	"./x-pseudo.js": 171,
	"./yo": 172,
	"./yo.js": 172,
	"./zh-cn": 173,
	"./zh-cn.js": 173,
	"./zh-hk": 174,
	"./zh-hk.js": 174,
	"./zh-tw": 175,
	"./zh-tw.js": 175
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 402;

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.8.7","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash.merge":"^4.6.0"},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 185,
	"./af.js": 185,
	"./ar": 186,
	"./ar-dz": 187,
	"./ar-dz.js": 187,
	"./ar-kw": 188,
	"./ar-kw.js": 188,
	"./ar-ly": 189,
	"./ar-ly.js": 189,
	"./ar-ma": 190,
	"./ar-ma.js": 190,
	"./ar-sa": 191,
	"./ar-sa.js": 191,
	"./ar-tn": 192,
	"./ar-tn.js": 192,
	"./ar.js": 186,
	"./az": 193,
	"./az.js": 193,
	"./be": 194,
	"./be.js": 194,
	"./bg": 195,
	"./bg.js": 195,
	"./bm": 196,
	"./bm.js": 196,
	"./bn": 197,
	"./bn.js": 197,
	"./bo": 198,
	"./bo.js": 198,
	"./br": 199,
	"./br.js": 199,
	"./bs": 200,
	"./bs.js": 200,
	"./ca": 201,
	"./ca.js": 201,
	"./cs": 202,
	"./cs.js": 202,
	"./cv": 203,
	"./cv.js": 203,
	"./cy": 204,
	"./cy.js": 204,
	"./da": 205,
	"./da.js": 205,
	"./de": 206,
	"./de-at": 207,
	"./de-at.js": 207,
	"./de-ch": 208,
	"./de-ch.js": 208,
	"./de.js": 206,
	"./dv": 209,
	"./dv.js": 209,
	"./el": 210,
	"./el.js": 210,
	"./en-au": 211,
	"./en-au.js": 211,
	"./en-ca": 212,
	"./en-ca.js": 212,
	"./en-gb": 213,
	"./en-gb.js": 213,
	"./en-ie": 214,
	"./en-ie.js": 214,
	"./en-nz": 215,
	"./en-nz.js": 215,
	"./eo": 216,
	"./eo.js": 216,
	"./es": 217,
	"./es-do": 218,
	"./es-do.js": 218,
	"./es-us": 219,
	"./es-us.js": 219,
	"./es.js": 217,
	"./et": 220,
	"./et.js": 220,
	"./eu": 221,
	"./eu.js": 221,
	"./fa": 222,
	"./fa.js": 222,
	"./fi": 223,
	"./fi.js": 223,
	"./fo": 224,
	"./fo.js": 224,
	"./fr": 225,
	"./fr-ca": 226,
	"./fr-ca.js": 226,
	"./fr-ch": 227,
	"./fr-ch.js": 227,
	"./fr.js": 225,
	"./fy": 228,
	"./fy.js": 228,
	"./gd": 229,
	"./gd.js": 229,
	"./gl": 230,
	"./gl.js": 230,
	"./gom-latn": 231,
	"./gom-latn.js": 231,
	"./gu": 232,
	"./gu.js": 232,
	"./he": 233,
	"./he.js": 233,
	"./hi": 234,
	"./hi.js": 234,
	"./hr": 235,
	"./hr.js": 235,
	"./hu": 236,
	"./hu.js": 236,
	"./hy-am": 237,
	"./hy-am.js": 237,
	"./id": 238,
	"./id.js": 238,
	"./is": 239,
	"./is.js": 239,
	"./it": 240,
	"./it.js": 240,
	"./ja": 241,
	"./ja.js": 241,
	"./jv": 242,
	"./jv.js": 242,
	"./ka": 243,
	"./ka.js": 243,
	"./kk": 244,
	"./kk.js": 244,
	"./km": 245,
	"./km.js": 245,
	"./kn": 246,
	"./kn.js": 246,
	"./ko": 247,
	"./ko.js": 247,
	"./ky": 248,
	"./ky.js": 248,
	"./lb": 249,
	"./lb.js": 249,
	"./lo": 250,
	"./lo.js": 250,
	"./lt": 251,
	"./lt.js": 251,
	"./lv": 252,
	"./lv.js": 252,
	"./me": 253,
	"./me.js": 253,
	"./mi": 254,
	"./mi.js": 254,
	"./mk": 255,
	"./mk.js": 255,
	"./ml": 256,
	"./ml.js": 256,
	"./mr": 257,
	"./mr.js": 257,
	"./ms": 258,
	"./ms-my": 259,
	"./ms-my.js": 259,
	"./ms.js": 258,
	"./mt": 260,
	"./mt.js": 260,
	"./my": 261,
	"./my.js": 261,
	"./nb": 262,
	"./nb.js": 262,
	"./ne": 263,
	"./ne.js": 263,
	"./nl": 264,
	"./nl-be": 265,
	"./nl-be.js": 265,
	"./nl.js": 264,
	"./nn": 266,
	"./nn.js": 266,
	"./pa-in": 267,
	"./pa-in.js": 267,
	"./pl": 268,
	"./pl.js": 268,
	"./pt": 269,
	"./pt-br": 270,
	"./pt-br.js": 270,
	"./pt.js": 269,
	"./ro": 271,
	"./ro.js": 271,
	"./ru": 272,
	"./ru.js": 272,
	"./sd": 273,
	"./sd.js": 273,
	"./se": 274,
	"./se.js": 274,
	"./si": 275,
	"./si.js": 275,
	"./sk": 276,
	"./sk.js": 276,
	"./sl": 277,
	"./sl.js": 277,
	"./sq": 278,
	"./sq.js": 278,
	"./sr": 279,
	"./sr-cyrl": 280,
	"./sr-cyrl.js": 280,
	"./sr.js": 279,
	"./ss": 281,
	"./ss.js": 281,
	"./sv": 282,
	"./sv.js": 282,
	"./sw": 283,
	"./sw.js": 283,
	"./ta": 284,
	"./ta.js": 284,
	"./te": 285,
	"./te.js": 285,
	"./tet": 286,
	"./tet.js": 286,
	"./th": 287,
	"./th.js": 287,
	"./tl-ph": 288,
	"./tl-ph.js": 288,
	"./tlh": 289,
	"./tlh.js": 289,
	"./tr": 290,
	"./tr.js": 290,
	"./tzl": 291,
	"./tzl.js": 291,
	"./tzm": 292,
	"./tzm-latn": 293,
	"./tzm-latn.js": 293,
	"./tzm.js": 292,
	"./uk": 294,
	"./uk.js": 294,
	"./ur": 295,
	"./ur.js": 295,
	"./uz": 296,
	"./uz-latn": 297,
	"./uz-latn.js": 297,
	"./uz.js": 296,
	"./vi": 298,
	"./vi.js": 298,
	"./x-pseudo": 299,
	"./x-pseudo.js": 299,
	"./yo": 300,
	"./yo.js": 300,
	"./zh-cn": 301,
	"./zh-cn.js": 301,
	"./zh-hk": 302,
	"./zh-hk.js": 302,
	"./zh-tw": 303,
	"./zh-tw.js": 303
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox sessions-app",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Sitzungen\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('h2',[_vm._v("Letzte 7 Tage")]),_vm._v(" "),(_vm.chartdata)?_c('line-chart',{staticClass:"lineChart",attrs:{"data":_vm.chartdata,"height":100}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-value sessions-app-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.sessionWebTotalValue,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])])],1),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle sessions-app-7days",class:[_vm.days7Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days7Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle sessions-app-14days",class:[_vm.days14Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days14Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle sessions-app-21days",class:[_vm.days21Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days21Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("21 Tage zuvor")])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sessions_web_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6f1ecf2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sessions_web_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sessions_web_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6f1ecf2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sessions_web_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox sessions-web",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Sitzungen\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('h2',[_vm._v("Letzte 7 Tage")]),_vm._v(" "),(_vm.chartdata)?_c('line-chart',{staticClass:"lineChart",attrs:{"data":_vm.chartdata,"height":100}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-value sessions-web-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.sessionWebTotalValue,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])])],1),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle sessions-web-7days",class:[_vm.days7Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days7Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle sessions-web-14days",class:[_vm.days14Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days14Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle sessions-web-21days",class:[_vm.days21Value < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.days21Value.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("21 Tage zuvor")])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48d0c2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_vue__ = __webpack_require__(450);
function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_engagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b48d0c2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_engagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox engagement",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Engagement\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('div',{staticClass:"total-value engagement-total",class:[_vm.totalValueEnd < 0 ? 'down' : 'up']},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":1,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"chartsBlock"},[(_vm.dataReactions)?_c('line-chart',{staticClass:"lineChart reactionsChart",attrs:{"data":_vm.dataReactions,"height":100}}):_vm._e(),_vm._v(" "),(_vm.dataComments)?_c('line-chart',{staticClass:"lineChart commentChart",attrs:{"data":_vm.dataComments,"height":100}}):_vm._e(),_vm._v(" "),(_vm.dataShares)?_c('line-chart',{staticClass:"lineChart sharesChart",attrs:{"data":_vm.dataShares,"height":100}}):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Veränderung")]),_vm._v(" "),_c('h3',[_vm._v("Interaktionen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Letzte 7 Tage")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Interaktionen")]),_vm._v(" "),_c('h3',[_vm._v("pro Tag")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fans_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1330134_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fans_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1330134_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox fans",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Entwicklung\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('div',{staticClass:"total-value fans-total",class:[_vm.totalValueEnd < 0 ? 'down' : 'up']},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":1,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"chartsBlock"},[(_vm.dataPaid)?_c('line-chart',{staticClass:"lineChart paidChart",attrs:{"data":_vm.dataPaid,"height":100}}):_vm._e(),_vm._v(" "),(_vm.dataOrganic)?_c('line-chart',{staticClass:"lineChart organicChart",attrs:{"data":_vm.dataOrganic,"height":100}}):_vm._e(),_vm._v(" "),(_vm.dataUnlikes)?_c('line-chart',{staticClass:"lineChart unlikesChart",attrs:{"data":_vm.dataUnlikes,"height":100}}):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Veränderung")]),_vm._v(" "),_c('h3',[_vm._v("Anzahl Fans")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Letzte 7 Tage")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Page likes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_impressions_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af82d05e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impressions_vue__ = __webpack_require__(456);
function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_impressions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af82d05e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impressions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox impressions",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))])])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('div',{staticClass:"total-value impressions-total",class:[_vm.totalValueEnd < 0 ? 'down' : 'up']},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":1,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"chartsBlock"},[(_vm.dataPaid)?_c('line-chart',{staticClass:"lineChart paidChart",attrs:{"data":_vm.dataPaid,"height":100}}):_vm._e(),_vm._v(" "),(_vm.dataOrganic)?_c('line-chart',{staticClass:"lineChart organicChart",attrs:{"data":_vm.dataOrganic,"height":100}}):_vm._e(),_vm._v(" "),(_vm.dataViral)?_c('line-chart',{staticClass:"lineChart viralChart",attrs:{"data":_vm.dataViral,"height":100}}):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Veränderung")]),_vm._v(" "),_c('h3',[_vm._v("Impressions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Letzte 7 Tage")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Impressions")]),_vm._v(" "),_c('h3',[_vm._v("pro Tag")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_reached_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169d84d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_reached_vue__ = __webpack_require__(459);
function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_reached_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169d84d7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_reached_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox users-reached",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Fans\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('div',{staticClass:"total-value users-reached-total"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":0,"duration":_vm.countDuration,"options":_vm.options}})],1)])]),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_vm._m(1),_vm._v(" "),(_vm.dataUserAge)?_c('bar-chart',{staticClass:"barChart",attrs:{"data-unit":"%","data":_vm.dataUserAge,"height":250}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Erreichte "),_c('div',{staticClass:"svg people-group"}),_vm._v(" Nutzer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Altersstruktur Fans")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_and_fans_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0e0ad4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_and_fans_vue__ = __webpack_require__(462);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_and_fans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0e0ad4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_and_fans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox users-and-fans",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Fans\n    ")])]),_vm._v(" "),_c('div',{staticClass:"total-value users-and-fans-total"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":0,"duration":_vm.countDuration,"options":_vm.options}})],1)]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box2"},[_vm._m(1),_vm._v(" "),(_vm.dataGender)?_c('pie-chart',{staticClass:"pieChart",attrs:{"data":_vm.dataGender,"data-unit":"%","height":180}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_vm._m(2),_vm._v(" "),(_vm.dataUserAge)?_c('bar-chart',{staticClass:"barChart",attrs:{"data-unit":"%","data":_vm.dataUserAge,"height":180}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Fans auf "),_c('div',{staticClass:"svg people-group-cheer"}),_vm._v(" Facebook")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Geschlechtsverteilung Fans")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('h2',[_vm._v("Altersstruktur Fans")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_sessions_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065db8c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_sessions_vue__ = __webpack_require__(465);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_sessions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065db8c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_sessions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox stream-sessions",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Session Starts pro Aggregator\n    ")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value stream-sessions-total-homepage"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueHomepageEnd,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceHomepage < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n          Homepage\n        ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.differenceHomepage,"duration":_vm.countDuration,"options":_vm.options}})],1)])]),_vm._v(" "),_c('div',{staticClass:"total-value stream-sessions-total-app"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueAppEnd,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceApp < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n          App\n        ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.differenceApp,"duration":_vm.countDuration,"options":_vm.options}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"total-value circle stream-sessions-total-radiode"},[_c('div',{staticClass:"big value"},[_vm._v("\n          "+_vm._s(_vm.totalValueRadiodeEnd.toLocaleString())+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceRadiode < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            radio.de\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_vm._v("\n            "+_vm._s(_vm.differenceRadiode.toLocaleString())+"\n          ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"total-value circle stream-sessions-total-vtuner"},[_c('div',{staticClass:"big value"},[_vm._v("\n          "+_vm._s(_vm.totalValueVtunerEnd.toLocaleString())+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceVtuner < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            vTuner\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_vm._v("\n            "+_vm._s(_vm.differenceVtuner.toLocaleString())+"\n          ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"total-value circle stream-sessions-total-tunein"},[_c('div',{staticClass:"big value"},[_vm._v("\n          "+_vm._s(_vm.totalValueTuneinEnd.toLocaleString())+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceTunein < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            TuneIn\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_vm._v("\n            "+_vm._s(_vm.differenceTunein.toLocaleString())+"\n          ")])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Letzte 7 Tage")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_duration_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79775985_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_duration_vue__ = __webpack_require__(468);
function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_duration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79775985_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_duration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox stream-duration",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Hördauer pro Aggregator\n    ")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value stream-duration-total-homepage"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueHomepageEnd,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceHomepage < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n          Homepage\n        ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.differenceHomepage,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}})],1)])]),_vm._v(" "),_c('div',{staticClass:"total-value stream-duration-total-app"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueAppEnd,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceApp < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n          App\n        ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.differenceApp,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"total-value circle stream-duration-total-radiode"},[_c('div',{staticClass:"big value"},[_vm._v("\n          "+_vm._s(_vm.totalValueRadiodeEnd.toString().replace('.', ','))+"\n          "),_c('span',{staticClass:"unit"},[_vm._v("min")])]),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceRadiode < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            radio.de\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_vm._v("\n            "+_vm._s(_vm.differenceRadiode.toString().replace('.', ','))+"\n          ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"total-value circle stream-duration-total-vtuner"},[_c('div',{staticClass:"big value"},[_vm._v("\n          "+_vm._s(_vm.totalValueVtunerEnd.toString().replace('.', ','))+"\n          "),_c('span',{staticClass:"unit"},[_vm._v("min")])]),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceVtuner < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            vTuner\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_vm._v("\n            "+_vm._s(_vm.differenceVtuner.toString().replace('.', ','))+"\n          ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"total-value circle stream-duration-total-tunein"},[_c('div',{staticClass:"big value"},[_vm._v("\n          "+_vm._s(_vm.totalValueTuneinEnd.toString().replace('.', ','))+"\n          "),_c('span',{staticClass:"unit"},[_vm._v("min")])]),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.differenceTunein < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            TuneIn\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_vm._v("\n            "+_vm._s(_vm.differenceTunein.toString().replace('.', ','))+"\n          ")])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Letzte 7 Tage")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_simulcasts_all_aggregators_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d2f214_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_simulcasts_all_aggregators_vue__ = __webpack_require__(471);
function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_simulcasts_all_aggregators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d2f214_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_simulcasts_all_aggregators_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox all-simulcasts-all-aggregators",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Simulcasts\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('h2',[_vm._v("Session starts")]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-sessions-yesterday-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionStartsYesterday,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-session-last7days-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionStartsLast7Days,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Letzte 7 Tage")])])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-sessions-14days",class:[_vm.sessionStarts14daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionStarts14daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-sessions-28days",class:[_vm.sessionStarts28daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionStarts28daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("28 Tage zuvor")])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_c('h2',[_vm._v("Hördauer")]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-duration-yesterday-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionDurationYesterday,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-duration-last7days-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionDurationLast7Days,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Letzte 7 Tage")])])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-duration-14days",class:[_vm.sessionDuration14daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionDuration14daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-duration-28days",class:[_vm.sessionDuration28daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionDuration28daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("28 Tage zuvor")])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_streams_all_aggregators_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbee15a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_streams_all_aggregators_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_streams_all_aggregators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbee15a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_streams_all_aggregators_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox all-streams-all-aggregators",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Session Starts\n    ")]),_vm._v(" "),_c('h2',[_vm._v("Letzte 7 Tage")])]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"total-value all-streams-all-aggregators-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":0,"duration":_vm.countDuration,"options":_vm.options}})],1)]),_vm._v(" "),(_vm.dataChart)?_c('line-chart',{staticClass:"lineChart",attrs:{"data":_vm.dataChart,"height":100}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_session_starts_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7137380_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_session_starts_vue__ = __webpack_require__(477);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_all_session_starts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7137380_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_all_session_starts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox all-session-starts",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Session Starts\n    ")]),_vm._v(" "),_c('h2',[_vm._v("Letzte 7 Tage")])]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value all-session-starts-total"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"decimals":1,"duration":_vm.countDuration,"options":_vm.options1}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1)]),_vm._v(" "),_c('div',{staticClass:"total-value all-session-starts-total"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueQualEnd,"decimals":1,"duration":_vm.countDuration,"options":_vm.options2}})],1)])]),_vm._v(" "),_c('div',{staticClass:"chartWrapper"},[_vm._m(2),_vm._v(" "),(_vm.dataSessionLength)?_c('pie-chart',{staticClass:"pieChart",attrs:{"data":_vm.dataSessionLength,"height":80}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('div',{staticClass:"svg average"}),_vm._v(" "),_c('h2',[_vm._v("Hördauer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('div',{staticClass:"svg bounce"}),_vm._v(" "),_c('h2',[_vm._v("Qualtitative Bouncerate")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headlineBlock"},[_c('div',{staticClass:"svg hear"}),_vm._v(" "),_c('h2',[_vm._v("Verteilung Sessions nach Hördauer")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_conversion_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_946875dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_conversion_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_conversion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_946875dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_conversion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox stream-conversion",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Stream Conversion\n    ")]),_vm._v(" "),_c('h2',[_vm._v("Homepage")]),_vm._v(" "),_c('p',[_vm._v("Generierte Sessions > 60 Sek. aus Sitzungen")])]),_vm._v(" "),_c('div',{staticClass:"centerBlock"},[_c('div',{staticClass:"svg website"}),_vm._v(" "),_c('div',{staticClass:"arrow stream-conversion-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueEnd,"duration":_vm.countDuration,"options":_vm.options}})],1)]),_vm._v(" "),_c('div',{staticClass:"svg stream"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_overview_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89a75e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89a75e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox overview",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Erreichte Nutzer\n    ")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"totalValuesBox"},[_c('div',{staticClass:"total-value engagement-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.engagementValue,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.engagementDiff < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            Engagement\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.engagementDiff,"duration":_vm.countDuration,"options":_vm.options}})],1)])]),_vm._v(" "),_c('div',{staticClass:"total-value impressions-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.impressionsValue,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.impressionsDiff < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            Impressions\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.impressionsDiff,"duration":_vm.countDuration,"options":_vm.options}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"totalValuesBox"},[_c('div',{staticClass:"total-value users-reached-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.usersReachedValue,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"source-difference",class:_vm.usersReachedDiff < 0 ? 'down' : 'up'},[_c('span',{staticClass:"source-difference-type"},[_vm._v("\n            Users reached\n          ")]),_vm._v(" "),_c('span',{staticClass:"source-difference-value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.usersReachedDiff,"duration":_vm.countDuration,"options":_vm.options}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Letzte 7 Tage")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("7 Tage zuvor")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_streams_web_only_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b3e875_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_streams_web_only_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_streams_web_only_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b3e875_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_streams_web_only_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideBox all-simulcasts-all-aggregators all-webonlys-all-aggregators",class:this.$route.query.source},[_c('div',{staticClass:"slideHeader"},[_c('h1',[_c('span',{staticClass:"source"},[_vm._v(_vm._s(this.$route.query.sourceTitle))]),_vm._v("\n      Web only\n    ")])]),_vm._v(" "),_c('div',{staticClass:"layoutWrapper"},[_c('div',{staticClass:"layoutBox box1"},[_c('h2',[_vm._v("Session starts")]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-sessions-yesterday-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionStartsYesterday,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-session-last7days-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionStartsLast7Days,"duration":_vm.countDuration,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Letzte 7 Tage")])])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-sessions-14days",class:[_vm.sessionStarts14daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionStarts14daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-sessions-28days",class:[_vm.sessionStarts28daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionStarts28daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("28 Tage zuvor")])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"layoutBox box2"},[_c('h2',[_vm._v("Hördauer")]),_vm._v(" "),_c('div',{staticClass:"totalValuesWrapper"},[_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-duration-yesterday-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionDurationYesterday,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Gestern")])]),_vm._v(" "),_c('div',{staticClass:"total-value all-simulcasts-all-aggregators-stream-duration-last7days-total"},[_c('div',{staticClass:"big value"},[_c('i-count-up',{attrs:{"start":0,"end":_vm.totalValueSessionDurationLast7Days,"duration":_vm.countDuration,"decimals":1,"options":_vm.options}}),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v("min")])],1),_vm._v(" "),_c('div',{staticClass:"day"},[_vm._v("Letzte 7 Tage")])])]),_vm._v(" "),_c('div',{staticClass:"circles"},[_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-duration-14days",class:[_vm.sessionDuration14daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionDuration14daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("14 Tage zuvor")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"swap-in","appear":""}},[_c('div',{staticClass:"circle all-simulcasts-all-aggregators-stream-duration-28days",class:[_vm.sessionDuration28daysValue < 0 ? 'down' : 'up']},[_c('div',{staticClass:"big value"},[_vm._v(_vm._s(_vm.sessionDuration28daysValue.toString().replace('.', ','))+"%")]),_vm._v(" "),_c('div',{staticClass:"day"},[_c('span',{staticClass:"day-range-firstValue"},[_vm._v("Gestern")]),_vm._v(" "),_c('span',{staticClass:"day-range-divider"}),_vm._v(" "),_c('span',{staticClass:"day-range-secondValue"},[_vm._v("28 Tage zuvor")])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(51);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: true,

  state: {},

  actions: {
    loadConfig: function loadConfig(context, display) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var config = __webpack_require__(516)("./config-" + display + '.json');
        context.commit('LOAD_CONFIG', config);
        resolve();
      });
    },
    showNextSlide: function showNextSlide(context) {
      var newSlideID = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.head(context.state.slideOrder);
      var newSlideObject = context.state.allSlides[newSlideID];

      /* set path */
      var path = '';
      if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].history.current.path.indexOf(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].history.current.params.display + '/') !== -1) {
        path = newSlideObject.type;
      } else {
        path = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].history.current.params.display + '/' + newSlideObject.type;
      }

      /* route config */
      var routerPath = {
        path: path,
        query: {
          theme: newSlideObject.theme,
          id: newSlideObject.id,
          source: newSlideObject.source,
          sourceTitle: newSlideObject.sourceTitle
        }

        /* auto refresh via timestamp (prod. only) */
      };if (true) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.get('/static/build-timestamp.json').then(function (response) {
          if (context.state.buildTimestamp) {
            if (context.state.buildTimestamp !== response.timestamp) {
              /* flush sw caches */
              self.addEventListener('activate', function (event) {
                event.waitUntil(caches.keys().then(function (cacheNames) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(cacheNames.map(function (cacheName) {
                    return caches.delete(cacheName);
                  }));
                }));
              });
              setTimeout(function () {
                window.location.reload(true);
              }, 5000);
            }
          } else {
            context.commit('CHANGE_TIMESTAMP', response.timestamp);
          }
        }).fail(function (error) {
          console.log(error);
        });
      }

      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push(routerPath);
      context.commit('CHANGE_ORDER');
    }
  },

  mutations: {
    LOAD_CONFIG: function LOAD_CONFIG(state, config) {
      state.slideTimeout = config.slideTimeout;
      state.chartAnimationTime = config.chartAnimationTime;
      state.chartAnimationEasing = config.chartAnimationEasing;
      state.countDuration = config.countDuration;
      state.allSlides = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keyBy(config.slides, 'id');
      state.slideOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(config.slides, 'id');
    },
    CHANGE_ORDER: function CHANGE_ORDER(state, dir) {
      var order = state.slideOrder;
      order.push(order.shift());
    },
    CHANGE_TIMESTAMP: function CHANGE_TIMESTAMP(state, ts) {
      state.buildTimestamp = ts;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./config-1deutsch.json": 517,
	"./config-80s80s.json": 518,
	"./config-90s90s.json": 519,
	"./config-amv.json": 520,
	"./config-barbaradio.json": 521,
	"./config-bob.json": 522,
	"./config-d1-rsh.json": 523,
	"./config-d2-delta-bob.json": 524,
	"./config-d3-rsh-delta-bob.json": 525,
	"./config-delta.json": 526,
	"./config-digital-berlin.json": 527,
	"./config-digital.json": 528,
	"./config-feierfreund.json": 529,
	"./config-psr.json": 530,
	"./config-redaktion-amv.json": 531,
	"./config-redaktion-bob.json": 532,
	"./config-redaktion-delta.json": 533,
	"./config-redaktion-rsh.json": 534,
	"./config-rsa.json": 535,
	"./config-rsh.json": 536,
	"./config-rzl1-psr-rsa.json": 537,
	"./config-rzl2-psr-rsa.json": 538,
	"./config-rzl3-psr-rsa.json": 539,
	"./config-rzl4-psr-rsa.json": 540,
	"./config-rzl5-psr.json": 541,
	"./config-rzl6-rsa.json": 542,
	"./config-schlagerplanet.json": 543,
	"./config-ssl.json": 544,
	"./config-weihnachtsmusik.json": 545
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"1deutsch","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"1deutsch","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"1deutsch","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"1deutsch","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"1deutsch","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#d36d70","#2f4d78"],"chartColor":"#6f3f5d"},{"id":6,"theme":"1deutsch","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"1deutsch","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"1deutsch","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"1deutsch","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#6f3f5d"},{"id":10,"theme":"1deutsch","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#d36d70","#df9951","#2f4d78","#6f3f5d","#6fb792"]},{"id":11,"theme":"1deutsch","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"1deutsch","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"1deutsch","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"1deutsch","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#ff00c6"}]}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"80s80s","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"80s80s","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"80s80s","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"80s80s","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"80s80s","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#ff59a6","#4b5464"],"chartColor":"#4b5464"},{"id":6,"theme":"80s80s","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"80s80s","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"80s80s","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"80s80s","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4b5464"},{"id":10,"theme":"80s80s","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#4b5464","#fd593e","#f5a623","#34daae","#e05f9b"]},{"id":11,"theme":"80s80s","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"80s80s","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"80s80s","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"80s80s","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#e05f9b"}]}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"90s90s","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"90s90s","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"90s90s","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"90s90s","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"90s90s","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#f5a623","#656e76"],"chartColor":"#656e76"},{"id":6,"theme":"90s90s","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"90s90s","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"90s90s","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"90s90s","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#656e76"},{"id":10,"theme":"90s90s","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#656e76","#2a96ab","#f5a623","#954eff","#e05f9b"]},{"id":11,"theme":"90s90s","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"90s90s","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"90s90s","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"90s90s","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#ff00c6"}]}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"amv","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"amv","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"amv","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"amv","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"amv","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#2f92d6","pieChartColors":["#db1d09","#006db8"]},{"id":6,"theme":"amv","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"amv","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"amv","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"amv","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#2faed6"},{"id":10,"theme":"amv","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#80CA08","#FFC92B","#db1d09","#9cd7ff","#2f92d6"]},{"id":11,"theme":"amv","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"amv","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"amv","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"amv","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#882e9f"}]}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"barbaradio","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"barbaradio","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"barbaradio","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"barbaradio","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"barbaradio","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#7f7f7f","#f08da2"],"chartColor":"#7f7f7f"},{"id":6,"theme":"barbaradio","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"barbaradio","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"barbaradio","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"barbaradio","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#8bc7a1"},{"id":10,"theme":"barbaradio","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#7f7f7f","#8bc7a1","#f08da2","#e3be54","#3b5998"]},{"id":11,"theme":"barbaradio","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"barbaradio","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"barbaradio","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"barbaradio","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#e3be54"}]}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"bob","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"bob","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"bob","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"bob","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"bob","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick"},{"id":6,"theme":"bob","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"bob","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"bob","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"bob","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":10,"theme":"bob","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":11,"theme":"bob","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"bob","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"bob","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"bob","type":"sessions-web","source":"web","sourceTitle":"Website"}]}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"rsh","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4AADE7"},{"id":2,"theme":"rsh","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"rsh","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"rsh","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"rsh","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"rsh","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"rsh","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#a941aa"},{"id":8,"theme":"rsh","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"rsh","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#4AADE7"},{"id":10,"theme":"rsh","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"rsh","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"rsh","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"rsh","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"delta","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#6D8994"},{"id":2,"theme":"delta","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"delta","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"delta","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"delta","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"delta","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"delta","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#776C58"},{"id":8,"theme":"delta","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"delta","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#646363"},{"id":10,"theme":"delta","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"delta","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"delta","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"delta","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":14,"theme":"bob","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":15,"theme":"bob","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":16,"theme":"bob","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":17,"theme":"bob","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":18,"theme":"bob","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":19,"theme":"bob","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":20,"theme":"bob","type":"sessions-web","source":"web","sourceTitle":"Website"},{"id":21,"theme":"bob","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":22,"theme":"bob","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick"},{"id":23,"theme":"bob","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":24,"theme":"bob","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":25,"theme":"bob","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":26,"theme":"bob","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"rsh","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4AADE7"},{"id":2,"theme":"rsh","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"rsh","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"rsh","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"rsh","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"rsh","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"rsh","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#a941aa"},{"id":8,"theme":"rsh","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"rsh","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#4AADE7"},{"id":10,"theme":"rsh","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"rsh","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"rsh","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"rsh","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":14,"theme":"delta","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#6D8994"},{"id":15,"theme":"delta","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":16,"theme":"delta","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":17,"theme":"delta","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":18,"theme":"delta","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":19,"theme":"delta","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":20,"theme":"delta","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#776C58"},{"id":21,"theme":"delta","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":22,"theme":"delta","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#646363"},{"id":23,"theme":"delta","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":24,"theme":"delta","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":25,"theme":"delta","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":26,"theme":"delta","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":27,"theme":"bob","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":28,"theme":"bob","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":29,"theme":"bob","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":30,"theme":"bob","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":31,"theme":"bob","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":32,"theme":"bob","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":33,"theme":"bob","type":"sessions-web","source":"web","sourceTitle":"Website"},{"id":34,"theme":"bob","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":35,"theme":"bob","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick"},{"id":36,"theme":"bob","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":37,"theme":"bob","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":38,"theme":"bob","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":39,"theme":"bob","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"delta","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"delta","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"delta","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"delta","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"delta","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#646363"},{"id":6,"theme":"delta","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"delta","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"delta","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"delta","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#6D8994"},{"id":10,"theme":"delta","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":11,"theme":"delta","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"delta","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"delta","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"delta","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#776C58"}]}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"80s80s","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"80s80s","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"80s80s","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"80s80s","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"80s80s","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#ff59a6","#4b5464"],"chartColor":"#4b5464"},{"id":6,"theme":"80s80s","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"80s80s","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"80s80s","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"80s80s","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4b5464"},{"id":10,"theme":"80s80s","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#4b5464","#fd593e","#f5a623","#34daae","#e05f9b"]},{"id":11,"theme":"80s80s","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"80s80s","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"80s80s","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"80s80s","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#e05f9b"},{"id":15,"theme":"90s90s","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":16,"theme":"90s90s","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":17,"theme":"90s90s","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":18,"theme":"90s90s","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":19,"theme":"90s90s","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#f5a623","#656e76"],"chartColor":"#656e76"},{"id":20,"theme":"90s90s","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":21,"theme":"90s90s","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":22,"theme":"90s90s","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":23,"theme":"90s90s","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#656e76"},{"id":24,"theme":"90s90s","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#656e76","#2a96ab","#f5a623","#954eff","#e05f9b"]},{"id":25,"theme":"90s90s","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":26,"theme":"90s90s","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":27,"theme":"90s90s","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":28,"theme":"90s90s","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#ff00c6"},{"id":29,"theme":"schlagerplanet","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":30,"theme":"schlagerplanet","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":31,"theme":"schlagerplanet","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":32,"theme":"schlagerplanet","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":33,"theme":"schlagerplanet","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#b8197d","#afa997"],"chartColor":"#6c5d48"},{"id":34,"theme":"schlagerplanet","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":35,"theme":"schlagerplanet","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":36,"theme":"schlagerplanet","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":37,"theme":"schlagerplanet","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#7a6a52"},{"id":38,"theme":"schlagerplanet","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#6c5f7e","#f5a623","#7f7f7f","#b8197d","#7a6a52"]},{"id":39,"theme":"schlagerplanet","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":40,"theme":"schlagerplanet","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":41,"theme":"schlagerplanet","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":42,"theme":"schlagerplanet","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#99907a"}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"80s80s","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"80s80s","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"80s80s","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"80s80s","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"80s80s","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#ff59a6","#4b5464"],"chartColor":"#4b5464"},{"id":6,"theme":"80s80s","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"80s80s","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"80s80s","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"80s80s","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4b5464"},{"id":10,"theme":"80s80s","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#4b5464","#fd593e","#f5a623","#34daae","#e05f9b"]},{"id":11,"theme":"80s80s","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"80s80s","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"80s80s","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"80s80s","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#e05f9b"},{"id":15,"theme":"90s90s","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":16,"theme":"90s90s","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":17,"theme":"90s90s","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":18,"theme":"90s90s","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":19,"theme":"90s90s","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#f5a623","#656e76"],"chartColor":"#656e76"},{"id":20,"theme":"90s90s","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":21,"theme":"90s90s","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":22,"theme":"90s90s","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":23,"theme":"90s90s","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#656e76"},{"id":24,"theme":"90s90s","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#656e76","#2a96ab","#f5a623","#954eff","#e05f9b"]},{"id":25,"theme":"90s90s","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":26,"theme":"90s90s","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":27,"theme":"90s90s","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":28,"theme":"90s90s","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#ff00c6"},{"id":29,"theme":"1deutsch","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":30,"theme":"1deutsch","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":31,"theme":"1deutsch","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":32,"theme":"1deutsch","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":33,"theme":"1deutsch","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#d36d70","#2f4d78"],"chartColor":"#6f3f5d"},{"id":34,"theme":"1deutsch","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":35,"theme":"1deutsch","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":36,"theme":"1deutsch","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":37,"theme":"1deutsch","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#6f3f5d"},{"id":38,"theme":"1deutsch","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#d36d70","#df9951","#2f4d78","#6f3f5d","#6fb792"]},{"id":39,"theme":"1deutsch","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":40,"theme":"1deutsch","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":41,"theme":"1deutsch","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":42,"theme":"1deutsch","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#ff00c6"},{"id":43,"theme":"schlagerplanet","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":44,"theme":"schlagerplanet","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":45,"theme":"schlagerplanet","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":46,"theme":"schlagerplanet","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":47,"theme":"schlagerplanet","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#b8197d","#afa997"],"chartColor":"#6c5d48"},{"id":48,"theme":"schlagerplanet","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":49,"theme":"schlagerplanet","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":50,"theme":"schlagerplanet","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":51,"theme":"schlagerplanet","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#7a6a52"},{"id":52,"theme":"schlagerplanet","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#6c5f7e","#f5a623","#7f7f7f","#b8197d","#7a6a52"]},{"id":53,"theme":"schlagerplanet","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":54,"theme":"schlagerplanet","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":55,"theme":"schlagerplanet","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":56,"theme":"schlagerplanet","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#99907a"},{"id":57,"theme":"feierfreund","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":58,"theme":"feierfreund","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":59,"theme":"feierfreund","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":60,"theme":"feierfreund","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":61,"theme":"feierfreund","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#f5a623","#790ca8"],"chartColor":"#00dacd"},{"id":62,"theme":"feierfreund","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":63,"theme":"feierfreund","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":64,"theme":"feierfreund","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":65,"theme":"feierfreund","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#00dacd"},{"id":66,"theme":"feierfreund","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#790ca8","#f5a623","#ff006b","#00c2ff","#d200ff"]},{"id":67,"theme":"feierfreund","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":68,"theme":"feierfreund","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":69,"theme":"feierfreund","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":70,"theme":"feierfreund","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#00dacd"},{"id":71,"theme":"weihnachtsmusik","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":72,"theme":"weihnachtsmusik","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":73,"theme":"weihnachtsmusik","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":74,"theme":"weihnachtsmusik","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":75,"theme":"weihnachtsmusik","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#c02f53","#08478e"],"chartColor":"#08478e"},{"id":76,"theme":"weihnachtsmusik","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":77,"theme":"weihnachtsmusik","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":78,"theme":"weihnachtsmusik","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":79,"theme":"weihnachtsmusik","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#e9454f"},{"id":80,"theme":"weihnachtsmusik","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#08478e","#c02f53","#1488c9","#ae7231","#2fa3c0"]},{"id":81,"theme":"weihnachtsmusik","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":82,"theme":"weihnachtsmusik","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":83,"theme":"weihnachtsmusik","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":84,"theme":"weihnachtsmusik","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#2fa3c0"},{"id":85,"theme":"barbaradio","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":86,"theme":"barbaradio","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":87,"theme":"barbaradio","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":88,"theme":"barbaradio","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":89,"theme":"barbaradio","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#7f7f7f","#f08da2"],"chartColor":"#7f7f7f"},{"id":90,"theme":"barbaradio","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":91,"theme":"barbaradio","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":92,"theme":"barbaradio","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":93,"theme":"barbaradio","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#8bc7a1"},{"id":94,"theme":"barbaradio","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#7f7f7f","#8bc7a1","#f08da2","#e3be54","#3b5998"]},{"id":95,"theme":"barbaradio","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":96,"theme":"barbaradio","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":97,"theme":"barbaradio","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":98,"theme":"barbaradio","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#e3be54"}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"feierfreund","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"feierfreund","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"feierfreund","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"feierfreund","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"feierfreund","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#f5a623","#790ca8"],"chartColor":"#00dacd"},{"id":6,"theme":"feierfreund","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"feierfreund","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"feierfreund","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"feierfreund","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#00dacd"},{"id":10,"theme":"feierfreund","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#790ca8","#f5a623","#ff006b","#00c2ff","#d200ff"]},{"id":11,"theme":"feierfreund","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"feierfreund","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"feierfreund","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"feierfreund","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#00dacd"}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"psr","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"psr","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"psr","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"psr","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"psr","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#45C080","pieChartColors":["#4abf83","#fbcd2f"]},{"id":6,"theme":"psr","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"psr","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"psr","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"psr","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#3B987A"},{"id":10,"theme":"psr","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#009545","#075986","#D37200","#D32F00","#FECD00"]},{"id":11,"theme":"psr","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"psr","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"psr","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"psr","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#40983B"}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"amv","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#2faed6"},{"id":2,"theme":"amv","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#80CA08","#FFC92B","#db1d09","#9cd7ff","#2f92d6"]},{"id":3,"theme":"amv","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"amv","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"amv","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"amv","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"amv","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#882e9f"},{"id":8,"theme":"amv","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"amv","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#2f92d6","pieChartColors":["#db1d09","#006db8"]},{"id":10,"theme":"amv","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"amv","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"amv","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"amv","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"bob","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":2,"theme":"bob","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"bob","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"bob","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"bob","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"bob","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"bob","type":"sessions-web","source":"web","sourceTitle":"Website"},{"id":8,"theme":"bob","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"bob","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick"},{"id":10,"theme":"bob","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"bob","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"bob","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"bob","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"delta","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#6D8994"},{"id":2,"theme":"delta","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"delta","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"delta","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"delta","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"delta","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"delta","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#776C58"},{"id":8,"theme":"delta","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"delta","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#646363"},{"id":10,"theme":"delta","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"delta","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"delta","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"delta","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"rsh","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4AADE7"},{"id":2,"theme":"rsh","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"rsh","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"rsh","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"rsh","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"rsh","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"rsh","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#a941aa"},{"id":8,"theme":"rsh","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"rsh","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#4AADE7"},{"id":10,"theme":"rsh","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"rsh","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"rsh","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"rsh","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"rsa","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"rsa","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"rsa","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"rsa","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"rsa","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#6AB7E4"},{"id":6,"theme":"rsa","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":6,"theme":"rsa","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"rsa","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"rsa","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#009FEC"},{"id":10,"theme":"rsa","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":11,"theme":"rsa","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"rsa","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"rsa","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"rsa","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#3A627D"}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"rsh","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"rsh","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"rsh","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"rsh","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"rsh","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#4AADE7"},{"id":6,"theme":"rsh","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"rsh","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"rsh","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"rsh","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#4AADE7"},{"id":10,"theme":"rsh","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":11,"theme":"rsh","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"rsh","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"rsh","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"rsh","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#a941aa"}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"psr","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#3B987A"},{"id":2,"theme":"psr","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#009545","#075986","#D37200","#D32F00","#FECD00"]},{"id":3,"theme":"psr","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"psr","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"psr","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"psr","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"psr","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#40983B"},{"id":8,"theme":"psr","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"psr","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#45C080","pieChartColors":["#4abf83","#fbcd2f"]},{"id":10,"theme":"psr","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"psr","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"psr","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"psr","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":14,"theme":"rsa","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#009FEC"},{"id":15,"theme":"rsa","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":16,"theme":"rsa","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":17,"theme":"rsa","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":18,"theme":"rsa","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":19,"theme":"rsa","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":20,"theme":"rsa","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#3A627D"},{"id":21,"theme":"rsa","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":22,"theme":"rsa","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#6AB7E4"},{"id":23,"theme":"rsa","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":24,"theme":"rsa","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":25,"theme":"rsa","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":26,"theme":"rsa","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"psr","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#3B987A"},{"id":2,"theme":"psr","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#009545","#075986","#D37200","#D32F00","#FECD00"]},{"id":3,"theme":"psr","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"psr","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"psr","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"psr","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"psr","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#40983B"},{"id":8,"theme":"psr","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"psr","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#45C080","pieChartColors":["#4abf83","#fbcd2f"]},{"id":10,"theme":"psr","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"psr","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"psr","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"psr","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":14,"theme":"rsa","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#009FEC"},{"id":15,"theme":"rsa","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":16,"theme":"rsa","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":17,"theme":"rsa","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":18,"theme":"rsa","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":19,"theme":"rsa","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":20,"theme":"rsa","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#3A627D"},{"id":21,"theme":"rsa","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":22,"theme":"rsa","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#6AB7E4"},{"id":23,"theme":"rsa","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":24,"theme":"rsa","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":25,"theme":"rsa","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":26,"theme":"rsa","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"psr","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#3B987A"},{"id":2,"theme":"psr","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#009545","#075986","#D37200","#D32F00","#FECD00"]},{"id":3,"theme":"psr","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"psr","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"psr","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"psr","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"psr","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#40983B"},{"id":8,"theme":"psr","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"psr","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#45C080","pieChartColors":["#4abf83","#fbcd2f"]},{"id":10,"theme":"psr","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"psr","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"psr","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"psr","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":14,"theme":"rsa","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#009FEC"},{"id":15,"theme":"rsa","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":16,"theme":"rsa","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":17,"theme":"rsa","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":18,"theme":"rsa","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":19,"theme":"rsa","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":20,"theme":"rsa","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#3A627D"},{"id":21,"theme":"rsa","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":22,"theme":"rsa","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#6AB7E4"},{"id":23,"theme":"rsa","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":24,"theme":"rsa","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":25,"theme":"rsa","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":26,"theme":"rsa","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"psr","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#3B987A"},{"id":2,"theme":"psr","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#009545","#075986","#D37200","#D32F00","#FECD00"]},{"id":3,"theme":"psr","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"psr","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"psr","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"psr","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"psr","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#40983B"},{"id":8,"theme":"psr","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"psr","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#45C080","pieChartColors":["#4abf83","#fbcd2f"]},{"id":10,"theme":"psr","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"psr","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"psr","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"psr","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":14,"theme":"rsa","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#009FEC"},{"id":15,"theme":"rsa","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":16,"theme":"rsa","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":17,"theme":"rsa","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":18,"theme":"rsa","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":19,"theme":"rsa","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":20,"theme":"rsa","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#3A627D"},{"id":21,"theme":"rsa","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":22,"theme":"rsa","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#6AB7E4"},{"id":23,"theme":"rsa","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":24,"theme":"rsa","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":25,"theme":"rsa","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":26,"theme":"rsa","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"psr","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#3B987A"},{"id":2,"theme":"psr","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#009545","#075986","#D37200","#D32F00","#FECD00"]},{"id":3,"theme":"psr","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"psr","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"psr","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"psr","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"psr","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#40983B"},{"id":8,"theme":"psr","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"psr","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#45C080","pieChartColors":["#4abf83","#fbcd2f"]},{"id":10,"theme":"psr","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"psr","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"psr","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"psr","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"rsa","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#009FEC"},{"id":2,"theme":"rsa","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream"},{"id":3,"theme":"rsa","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":4,"theme":"rsa","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":5,"theme":"rsa","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":6,"theme":"rsa","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":7,"theme":"rsa","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#3A627D"},{"id":8,"theme":"rsa","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":9,"theme":"rsa","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":"#6AB7E4"},{"id":10,"theme":"rsa","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":11,"theme":"rsa","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":12,"theme":"rsa","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":13,"theme":"rsa","type":"engagement","source":"facebook","sourceTitle":"Audience"}]}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"schlagerplanet","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"schlagerplanet","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"schlagerplanet","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"schlagerplanet","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"schlagerplanet","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#b8197d","#afa997"],"chartColor":"#6c5d48"},{"id":6,"theme":"schlagerplanet","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"schlagerplanet","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"schlagerplanet","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"schlagerplanet","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#7a6a52"},{"id":10,"theme":"schlagerplanet","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#6c5f7e","#f5a623","#7f7f7f","#b8197d","#7a6a52"]},{"id":11,"theme":"schlagerplanet","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"schlagerplanet","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"schlagerplanet","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"schlagerplanet","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#99907a"}]}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"ssl","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"ssl","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"ssl","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"ssl","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"ssl","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","chartColor":["#0c619e","#0c619e","#0c619e","#fd7d23","#0c619e","#0c619e","#0c619e"],"pieChartColors":["#0c619e","#fd7d23","#c0c0c0"]},{"id":6,"theme":"ssl","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"ssl","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"ssl","type":"all-simulcasts-all-aggregators","source":"stream_sessions","sourceTitle":"Stream"},{"id":9,"theme":"ssl","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#0c619e"},{"id":10,"theme":"ssl","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#0c619e","#fd7d23","#D2D2D2","#c0c0c0","#A2A2A2"]},{"id":11,"theme":"ssl","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"ssl","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"ssl","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"ssl","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#0c619e"}]}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {"slideTimeout":15000,"countDuration":2,"chartAnimationTime":1200,"chartAnimationEasing":"easeInOutExpo","slides":[{"id":1,"theme":"weihnachtsmusik","type":"engagement","source":"facebook","sourceTitle":"Audience"},{"id":2,"theme":"weihnachtsmusik","type":"fans","source":"facebook","sourceTitle":"Fanbase"},{"id":3,"theme":"weihnachtsmusik","type":"overview","source":"facebook","sourceTitle":"Facebook"},{"id":4,"theme":"weihnachtsmusik","type":"impressions","source":"facebook","sourceTitle":"Impressions"},{"id":5,"theme":"weihnachtsmusik","type":"users-and-fans","source":"facebook","sourceTitle":"Überblick","pieChartColors":["#c02f53","#08478e"],"chartColor":"#08478e"},{"id":6,"theme":"weihnachtsmusik","type":"stream-sessions","source":"all_streams","sourceTitle":"Stream"},{"id":7,"theme":"weihnachtsmusik","type":"stream-duration","source":"all_streams","sourceTitle":"Stream"},{"id":8,"theme":"weihnachtsmusik","type":"streams-web-only","source":"all_streams","sourceTitle":"Stream"},{"id":9,"theme":"weihnachtsmusik","type":"all-streams-all-aggregators","source":"stream_sessions","sourceTitle":"Stream","chartColor":"#e9454f"},{"id":10,"theme":"weihnachtsmusik","type":"all-session-starts","source":"stream_duration","sourceTitle":"Stream","pieChartColors":["#08478e","#c02f53","#1488c9","#ae7231","#2fa3c0"]},{"id":11,"theme":"weihnachtsmusik","type":"stream-conversion","source":"web","sourceTitle":"Website"},{"id":12,"theme":"weihnachtsmusik","type":"daily-active-users-web","source":"web","sourceTitle":"Website"},{"id":13,"theme":"weihnachtsmusik","type":"monthly-active-users-web","source":"web","sourceTitle":"Website"},{"id":14,"theme":"weihnachtsmusik","type":"sessions-web","source":"web","sourceTitle":"Website","chartColor":"#2fa3c0"}]}

/***/ })
],[330]);


// WEBPACK FOOTER //
// static/js/app.ab5e29adc11644ab0c55.js